import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C51SideStatisticsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  Cta?: LinkField;
};

export type C51SideStatisticsParams = {
  HeadlineTag?: string;
  BackgroundColor?: string;
  ContentAlignments?: string;
  CtaAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C51SideStatisticsProps = RenderingProps<
  C51SideStatisticsFields,
  C51SideStatisticsParams
>;
